import { useEffect, useState } from 'react';
import { PageSmallLoader } from '../../../component/PageLoader';
import { getDate } from '../../../utils/dateUtils';
import { getStatusColor } from '../utils';
import { cardTableColumnConfig } from '../data';
import { fetchDashboardCardData } from '../../../services/dashboard';
import filterIcon from '../../../assets/image/filter_icon.svg';
import verticalIcon from '../../../assets/image/vector_icon.svg';
import vectorIcon from '../../../assets/image/vector_horizontal_icon.svg';
import { useNavigate } from 'react-router-dom';
import { addDays } from 'date-fns';

const TableCard = ({ card, isCustomizing, handleRemoveCard, filter }) => {
	const { title, layout_card_id } = card;
	const [tableConfig, setTableConfig] = useState({
		columns: [],
		data: [],
	});
	const [isLoading, setLoading] = useState(false);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();

	const handleFetchCardData = async () => {
		try {
			setLoading(true);
			const data = await fetchDashboardCardData(layout_card_id, {
				page_size: 6,
				filter_by: filter.filter_by,
				start_date:
					filter.start_date !== null ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date:
					filter.end_date !== null ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
			const tableData = data[layout_card_id].map((inv, i) => {
				return {
					id: inv.id || i,
					customer: { name: inv.customer.name, date: inv.date } || 'Customer Name',
					status: inv.status,
					amount: inv.total_amount,
				};
			});
			setTableConfig((prev) => ({
				...prev,
				columns: cardTableColumnConfig[layout_card_id],
				data: tableData,
			}));
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (filter.filter_by === 'custom_date' && !filter.start_date && !filter.end_date) return;
		handleFetchCardData();
	}, [filter]);

	return (
		<div className="flex flex-col bg-white rounded-top-4">
			{isCustomizing && (
				<div
					style={{
						position: 'absolute',
						top: -13,
						right: -13,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						width: '20px',
						height: '20px',
						backgroundColor: 'red',
						borderRadius: '50%',
						cursor: 'pointer',
						zIndex: 100,
					}}
					onClick={(e) => {
						handleRemoveCard(layout_card_id, e);
					}}
				>
					<div
						style={{
							color: '#000',
							fontSize: '16px',
							fontWeight: '600',
							lineHeight: '1',
							paddingBottom: '5px',
						}}
					>
						−
					</div>
				</div>
			)}

			<div className="px-3 py-3 d-flex justify-content-between grids-header-bg-color rounded-top-4">
				<h3 className="fs-4 font-semibold  text-dark">{title}</h3>
				<div className="d-flex flex-row item-center gap-4">
					<div
						className="text-bold fs-5 cursor-pointer text-primary"
						onClick={() => {
							if (!isCustomizing) {
								navigate(`/user/${suburl}/invoices`);
							}
						}}
					>
						View All
					</div>
					<img
						className="cursor-pointer"
						src={filterIcon}
						alt=""
						width={15}
						height={15}
					/>
					<img
						src={vectorIcon}
						alt=""
						width={15}
						height={15}
						className="cursor-pointer"
					/>
					<img
						src={verticalIcon}
						alt=""
						width={15}
						height={15}
						className="cursor-pointer"
					/>
				</div>
			</div>
			{isLoading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: '300px' }}
				>
					<PageSmallLoader />
				</div>
			) : (
				<div className="flex-1 overflow-auto">
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="table-bg-color">
							<tr>
								{tableConfig.columns?.map((column, index) => (
									<th
										key={column.key}
										className="px-6 py-3 fs-5 border-b text-align-left py-1 table-bg-color"
										style={{ textAlign: index === 1 ? 'left' : 'center' }}
									>
										{column.title}
									</th>
								))}
							</tr>
						</thead>
						<tbody className="bg-white">
							{tableConfig.data.length === 0 ? (
								<tr>
									<td
										colSpan="4"
										className="table-bg-color border-0"
										style={{ height: '200px' }}
									>
										<div className="d-flex justify-content-center align-items-center w-100 h-100 ">
											<span className="fs-5 lead">No data found!</span>
										</div>
									</td>
								</tr>
							) : (
								tableConfig.data.map((row, i) => (
									<tr
										key={i}
										className="border-0 py-1"
									>
										<td className="py-1 fs-5 table-bg-color border-0">{i + 1}</td>
										<td className="py-1 table-bg-color text-start border-0">
											<div className="fs-5">{row.customer.name}</div>
											<div className="fs-6 text-secondary">{getDate(row.customer.date)}</div>
										</td>
										<td className="py-1 table-bg-color border-0">
											<div
												className="px-2 py-1 rounded-3 fs-5 text-dark"
												style={{ backgroundColor: getStatusColor(row.status) }}
											>
												{row.status}
											</div>
										</td>
										<td className="py-1 fs-5 table-bg-color border-0">{`₹ ${row.amount}`}</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};
export default TableCard;
